/* eslint-disable indent,space-before-function-paren */
import { VNode, VueConstructor } from 'vue';
import { defineComponent, onUnmounted } from '@vue/composition-api';
import { SpecificPropsType } from '@/components/form/types';
import ConfForm from '@/components/form/form';

export const formItemProps = <
    T extends any = any,
    Other extends Record<string, any> = {},
>(
    type?: any,
    other?: any,
) =>
    ({
        value: type
            ? {
                  type,
              }
            : {},
        form: {},
        node: {},
        ...other,
    } as unknown as SpecificPropsType<
        {
            value: T;
            form: InstanceType<typeof ConfForm>;
        } & Other
    >);

const cacheFunctionComponent = new WeakMap<Function, VueConstructor>();

export const transformComponent = (
    comp: VueConstructor | ((...p: any[]) => VNode | null),
): VueConstructor => {
    return typeof comp === 'function'
        ? (() => {
              if (cacheFunctionComponent.has(comp)) {
                  return cacheFunctionComponent.get(comp)!;
              }
              const c = defineComponent({
                  name: 'form-item',
                  props: formItemProps(),
                  setup: (...args) => {
                      return function () {
                          // @ts-ignore
                          return comp.apply(this, args);
                      };
                  },
              });
              cacheFunctionComponent.set(comp, c);
              return c;
          })()
        : comp;
};
